import React from 'react';

import { Slug } from '../../../components';
import { useAppContext } from '../../../molecules';
import { getContactStateColor } from '../../../utilities';

type ContactStateProps = {
  campaignId?: string;
  campaignName?: string;

  className?: string;

  latest_contact_state?: string | null;
  latest_contact_state_label?: string | null;
  latest_contact_state_details?: string | null;
};

const ContactState: React.FC<ContactStateProps> = ({
  className,

  campaignId,
  campaignName,
  latest_contact_state,
  latest_contact_state_label,
  latest_contact_state_details,
}) => {
  const { meta } = useAppContext();
  if (!latest_contact_state) return null;

  const campaignsStrategy = meta.campaignsData.find(
    c => c.id === campaignId || c.name === campaignName
  )?.strategy;
  const field = campaignsStrategy?.monitoring_fields?.find(
    f => f.key === 'latest_contact_state'
  );

  const { default_style } = field || {};
  const currentStateMeta = field?.value_styles?.[latest_contact_state];

  if (currentStateMeta || default_style) {
    const label = currentStateMeta?.label;
    const { label: _, ...style } = currentStateMeta || {};
    const text = label || latest_contact_state_label || latest_contact_state;

    return (
      <Slug
        text={text}
        color={false}
        className={className}
        tooltip={latest_contact_state_details}
        style={(currentStateMeta ? style : default_style) || {}}
      />
    );
  }

  return (
    <Slug
      className={className}
      text={latest_contact_state_label}
      tooltip={latest_contact_state_details}
      color={getContactStateColor(latest_contact_state)}
    />
  );
};

export default React.memo(ContactState) as typeof ContactState;
